import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import AniRoutes from "./components/AniRoutes";
import Footer from "./components/Footer";
import Header from "./components/Header";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const [windowDimension, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });

  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimension]);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />

        {/* Header */}
        <Header windowDimension={windowDimension} />
        {/* Body */}
        <AniRoutes />
        {/* Footer */}
        <Footer windowDimension={windowDimension} />
      </BrowserRouter>
    </div>
  );
}

export default App;
